<template>
  <v-container class="pa-0" fluid>
    <v-card>
      <v-layout wrap class="card-bg-2">        
        <v-flex xs12 md5 data-ui-component="specimena-list" CLASS="divider-right">
          
          <v-card-title class="headline pb-0">Survey Types</v-card-title>
          <v-card-text class="py-0">
            <v-radio-group v-if="availableSurveyTypes && availableSurveyTypes.length > 0" v-model="selectedSurveyType" row>
              <template v-for="m in availableSurveyTypes">
                <v-radio color="info" :key="m" :label="m" :value="m"></v-radio>
              </template>
            </v-radio-group>
            <!-- <div class="py-4 secondary--text text--lighten-1" v-if="!analyteMediaTypes || analyteMediaTypes == 0">
              There are no media types available
            </div> -->
          </v-card-text>
          <v-divider />

          <v-card-title class="headline pb-2 specimen-info-card--title">
            Survey Specimens
            <v-spacer />
            <v-text-field v-model="search" label="Search" prepend-inner-icon="search" class="rounded font-weight-regular" hide-details clearable solo placeholder="Search specimen">
            </v-text-field>
          </v-card-title>
          <v-divider />
          <v-data-table :items="specimenceList" :headers="specimenTableHeaders" :search="search" :rows-per-page-items="specimenTableRowsPerPage">
            <template v-slot:items="props">
              <tr class="clickable" :active="isSelectedSpecimen(props.item)" @click="toggleSpecimen(props.item)">
                <td>
                  <v-radio-group hide-details :value="isSelectedSpecimen(props.item)">
                    <v-radio @click.prevent color="info" hide-details :value="true" />
                  </v-radio-group>
                </td>
                <!-- <td>{{ props.item.ImportedSpeciesId }}</td> -->
                <td>{{ props.item.SpeciesCode }}</td>                
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md7 data-ui-component="specimena-metadata" class="divider-left">
          <v-card-title class="headline pb-2 specimen-info-card--title">Information</v-card-title>
          <v-divider />
          <v-data-table :headers="informationTableHeaders" :items="specimenInformation" disable-initial-sort hide-headers hide-actions class="elevation-1">
            <template v-slot:items="{ item, index}">
              <tr :class="{ alternate: index % 2 == 0 }">
                <td class="text-xs-left font-weight-medium">{{ item.Field}}</td>
                <td class="text-xs-left">{{item.FieldValue}}</td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="pa-4 text-xs-center">
                <v-icon color="warning" large>filter_vintage</v-icon>
                <br />
                Please select a specimen
              </div>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import {
    prettyDateFormat,
  } from '@/components/mixins/MomentUtil'


  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  // import {
  //   calculateDisplayValue,
  // } from '@/components/generic/KVStore/kvValueHelper'
  export default {
    data() {
      return {
        search: '',
        selectedSpecimen: null,        
        selectedSurveyType: null,
        specimenTableHeaders: [{
          text: '',
          align: '',
          value: 'select',
          sortable: false,
        },
        // {
        //   text: 'Imported Species Id',
        //   align: 'left',
        //   value: 'ImportedSpeciesId',
        // },
        {
          text: 'Species',
          align: 'left',
          value: 'SpeciesCode',
        },        
        ],
        informationTableHeaders: [{
          text: 'Field',
          value: 'Field',
        },
        {
          text: 'FieldValue',
          value: 'FieldValue',
        },
        ],
        specimenInformation: [],
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      dataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.surveysEnvirodata)
        return data
      },
      availableSurveyTypes() {
        return this.dataSource.SurveyTypes
      },
      specimenceList() {
        var selectedSurveyType = this.selectedSurveyType
        if(selectedSurveyType == null) {
          return []
        }
        var matched = this.dataSource.SurveyInformations.find(x => x.SurveyType == selectedSurveyType).SpeciesInformation
        return matched
      },
      specimenTableRowsPerPage() {
        return [25, 50, {
          'text': '$vuetify.dataIterator.rowsPerPageAll',
          'value': -1,
        }]
      },
    },
    watch: {      
      selectedSpecimen() {
        if (this.selectedSpecimen == null) {
          this.specimenInformation = []
          return
        }

        let specimenData = [{
          Field: 'Id',
          FieldValue: this.selectedSpecimen.Id,
        },
        {
          Field: 'Imported Species Id',
          FieldValue: this.selectedSpecimen.ImportedSpeciesId,
        },
        {
          Field: 'Species',
          FieldValue: this.selectedSpecimen.SpeciesCode,
        },
        {
          Field: 'Number of Surveys',
          FieldValue: this.selectedSpecimen.NumberOfSurveys,
        },
        {
          Field: 'First Survey Date',
          FieldValue: moment(this.selectedSpecimen.FirstSurveyDate).format(prettyDateFormat),
        },
        {
          Field: 'Last Survey Date',
          FieldValue: moment(this.selectedSpecimen.LastSurveyDate).format(prettyDateFormat),
        },
        ]
        
        this.specimenInformation = specimenData
      },
    },
    methods: {
      isSelectedSpecimen(specimen) {
        if (this.selectedSpecimen == null) {
          return false
        }
        return this.selectedSpecimen.Id == specimen.Id
      },
      toggleSpecimen(specimen) {
        if (this.selectedSpecimen != null && this.selectedSpecimen.Id == specimen.Id) {
          this.selectedSpecimen = null
        } else {
          this.selectedSpecimen = specimen
        }
      },
    },
    created() {
      this.selectedSurveyType = this.dataSource.SurveyTypes[0]
    },
  }
</script>
<style scoped>
  .specimen-info-card--title {
    height: 100px;
  }
</style>
